<!--首页模块四-->
<template>
  <div style="font-family: Alibaba">
    <!--解决方案标题-->
    <div class='title'>
      <div>
        <h1>
          <i class="el-icon-caret-right"></i>{{ cnNameFour }}
        </h1>
        <p>{{ enNameFour }}</p>
      </div>
    </div>
    <!--解决方案-->
    <div>
      <el-row :span="24" class="box-width carbon background_img">
        <a href="#" class='card_box' @click='handleFourClick()'>
          <el-col :md="12" :sm="12" :xs="24">
            <div class="div_img">
              <el-image
                class="carbon_img"
                :fit='fit'
                v-if='homeFourVo.fullPathUrl != null'
                :src='homeFourVo.fullPathUrl'
              />
            </div>
          </el-col>
          <el-col :md="12" :sm="12" :xs="24">
            <div class="text">
              <h4>{{ homeFourVo.title }}</h4>
              <div v-html="homeFourVo.briefIntroduction" class="htmlImgSize" style="color: #606266"></div>
            </div>
          </el-col>
        </a>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findEnNameOne, findHomeFour } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameFour: '',
      cnNameFour: '',
      homeFourVo: {},
      fit: 'fill',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectFour()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameFour = data.enName
        that.cnNameFour = data.cnName
      })
    },
    async selectFour () {
      let that = this
      await findHomeFour().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeFourVo = res.data
      })
    },
    handleFourClick () {
      const routeData = this.$router.resolve({
        path: this.homeFourVo.linksVo.href,
        query: { tabId: this.homeFourVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
